import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Footer from 'components/footer/Footer';
import AppBar from 'components/appbar/XtraAppBar';
import { EventDatetimeContext } from 'components/EventDatetime';
import { useMediaQuery } from '@material-ui/core';
import { EVENT_NAME } from 'appenv';
import 'objectFitPolyfill';
import ResetEmailModal from '../../ResetEmailModal';
import RegisterButton from '../../RegisterButton';
import Countdown from '../../Countdown';
import DateText from '../../DateText';

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const MainContent = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${({ isDesktop }) => (isDesktop ? 0 : 64)}px;
  padding-top: 25px;

  @media (max-width: 600px) {
    margin-top: 56px;
  }
`;

const PageHeader = styled.div`
  flex: 0 0 auto;
`;

const PageFooter = styled.div`
  flex: 0 0 auto;
`;

const PageContent = styled.div`
  margin: 32px 0;
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'column-reverse' : 'column')};
  align-items: center;
  flex-shrink: 0;

  @media screen and (min-width: 960px) {
    margin-top: 0;
  }
`;

const WelcomeText = styled.div`
  color: #FFF;
  font-family: din, sans-serif;
  font-weight: 500;
  font-size: 30px;
  line-height: 60px;
  text-align: center;
  flex-shrink: 0;

  @media screen and (min-width: 400px) {
    font-size: 35px;
  }

  @media screen and (min-width: 600px) {
    font-size: 40px;
  }

  @media screen and (min-width: 960px) {
    font-size: 48px;
  }
`;

const MainFrame = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  overflow: auto;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

const ButtonContainer = styled.div`
  margin-top: 3vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BackgroundImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  z-index: -100;
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
`;

const StyledCountdown = styled(Countdown)`
  flex-shrink: 0;
`;

const REGISTRATION_LINK = 'https://app.eventxtra.com/registrations/e0463a8b-03fe-4c45-8555-4f9ea2a4583d?locale=en';

const LandingPage = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width: 960px)');
  const { hasEventStarted, startDatetime, endDatetime } = useContext(EventDatetimeContext);

  const [isResetEmailModalOpened, setIsResetEmailModalOpened] = useState(false);

  const openResetEmailModal = useCallback(() => {
    setIsResetEmailModalOpened(true);
  }, [setIsResetEmailModalOpened]);
  const handleResetEmailModalClose = useCallback(() => {
    setIsResetEmailModalOpened(false);
  }, [setIsResetEmailModalOpened]);
  const onRegisterNowBtnClick = useCallback(() => {
    window.open(REGISTRATION_LINK, '_blank');
  }, []);

  const backgroundImgSrc = 'https://contents-virtual.eventxtra.com/uploads/eventage_staging/originals/558b663b-1be8-45d2-89db-749a18dfac86.png';

  useEffect(() => {
    window.objectFitPolyfill();
  }, []);

  return (
    <PageContainer>
      <PageHeader>
        <AppBar hideUser hideDrawer hideSearchBar hideLinks />
      </PageHeader>
      <BackgroundImage src={backgroundImgSrc} />
      <MainFrame>
        <MainContent isDesktop={isDesktop}>
          <ResetEmailModal
            open={isResetEmailModalOpened}
            handleClose={handleResetEmailModalClose}
            onRegisterNowBtnClick={onRegisterNowBtnClick}
          />
          <WelcomeText>
            {EVENT_NAME}
          </WelcomeText>

          <DateText>
            <span>
              {`Date: ${startDatetime.tz('Asia/Karachi').format('DD MMMM')} 2020 - ${endDatetime.tz('Asia/Karachi').format('DD MMMM')} 2020`}
            </span>
            <span>
              {`Time: PKT ${startDatetime.tz('Asia/Karachi').format('hh:mm A')} -  ${endDatetime.tz('Asia/Karachi').format('hh:mm A')}`}
            </span>
          </DateText>
          {!hasEventStarted && <StyledCountdown />}
          <PageContent>
            <ButtonContainer>
              <RegisterButton
                href={REGISTRATION_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('lobby.register', 'Register')}
              </RegisterButton>
              <RegisterButton onClick={openResetEmailModal}>
                {t('lobby.registered', 'I have registered')}
              </RegisterButton>
            </ButtonContainer>
          </PageContent>
          <PageFooter>
            <Footer />
          </PageFooter>
        </MainContent>
      </MainFrame>
    </PageContainer>
  );
};

export default LandingPage;
